import React from "react";
import { AccessibilityClickableDiv } from "@skillz/accessibility";
import Icon from "../../icons/Icon";
import iconsList from "../../icons/iconsList";
import classes from "./BottomSheetHeader.module.css";

const BottomSheetHeader = ({ title, actionText, onAction, onClose, closeIconName = iconsList.x, dropClass, dropClassTitle, dropClassAction, dropClassClose }) => {
    return (
        <div className={`${classes.BottomSheetHeader} ${dropClass || ""}`}>
            <Icon name={closeIconName} size="24px" color="#111" className={`${classes.CloseButton} ${dropClassClose || ""}`} onClick={onClose} />
            <h2 className={`${classes.Title} ${dropClassTitle || ""}`}>{title}</h2>
            {actionText && <AccessibilityClickableDiv className={`${classes.Action} ${dropClassAction || ""}`} onClick={onAction} role="button">{actionText}</AccessibilityClickableDiv>}
        </div>
    );
};

export default BottomSheetHeader;
